import { TextField } from 'src/components/TextField';

import { VisitFilterSelectOption } from './constants';
import { useClientVisitFilterLabels } from './useClientVisitFilterLabels';

interface VisitFilterTimeframeFieldProps<T extends number> {
  label?: string;
  value?: T;
  options: VisitFilterSelectOption<T>[];
  onChange: (timeframeDays: T | undefined) => void;
  error?: boolean;
}

export const VisitFilterTimeframeField = <T extends number>({
  label,
  value,
  options,
  onChange,
  error = false,
}: VisitFilterTimeframeFieldProps<T>) => {
  const { timeframeLabel, selectPlaceholder } = useClientVisitFilterLabels();

  return (
    <TextField
      label={label ?? timeframeLabel}
      value={value ?? ''}
      onChange={(e) => {
        const raw = e.target.value;
        if (raw === '') {
          onChange(undefined);
          return;
        }

        onChange(Number(raw) as T);
      }}
      options={[
        { value: '', label: selectPlaceholder },
        ...options.map((option) => ({
          value: String(option.value),
          label: option.label,
        })),
      ]}
      error={error}
    />
  );
};
